/**
 * 基本信息统一配置中心
 * **/
import supplierModule from "./detail-base-info/supplier-detail-base-info";
export default {
  ...supplierModule
};
